export const LOGIN = 'login';
export const USER = 'user';
export const PASSWORD = 'password';
